import { OrderCreatedContext } from '../types';

// Record (not a switch) so adding a member to OrderCreatedContext is a
// compile error until it has a label.
const CREATED_CONTEXT_LABELS: Record<OrderCreatedContext, string> = {
  [OrderCreatedContext.ChocoApp]: 'Choco App',
  [OrderCreatedContext.ChocoAi]: 'Choco AI',
  [OrderCreatedContext.ChocoWeb]: 'Choco Web',
  [OrderCreatedContext.TeamOrder]: 'Team Order',
  [OrderCreatedContext.WhiteLabelApp]: 'White Label App',
  [OrderCreatedContext.WhiteLabelWeb]: 'White Label Web',
  [OrderCreatedContext.VoiceAgent]: 'Voice Agent',
  [OrderCreatedContext.IntegrationPublicApi]: 'Public API',
};

/**
 * Returns null for anything unrecognised, so the caller leaves the row out
 * rather than showing a value it cannot name.
 */
export const parseOrderCreatedContext = (
  value?: string | null
): OrderCreatedContext | null =>
  Object.values(OrderCreatedContext).find((context) => context === value) ??
  null;

export const formatOrderCreatedContext = (
  context?: OrderCreatedContext | null
): string | null => (context ? CREATED_CONTEXT_LABELS[context] : null);
